import Vue from 'vue';
import state from '../state';
import noty from './noty.service';

export default {
  async getByClient(filter) {
    return (await Vue.http.post('/api/players', filter)).data;
  },
  async getStatsByClient() {
    return (await Vue.http.get('/api/players/stats')).data;
  },
  async load(playerId) {
    const editPlayer = state.editPlayer.get();
    playerId = playerId || (editPlayer ? editPlayer.id : false);
    if (!playerId) return null;
    const player = (await Vue.http.get(`/api/players/get/${playerId}`)).data;
    state.editPlayer.set(player);
  },
  async lock(playerId) {
    let p = (await Vue.http.post(`/api/players/lock/${playerId}`)).data;
    noty.success('Player locked successfully');
    return p;
  },
  async unlock(playerId) {
    let p = (await Vue.http.post(`/api/players/unlock/${playerId}`)).data;
    noty.success('Player unlocked successfully');
    return p;
  }
}



// WEBPACK FOOTER //
// ./src/services/player.service.js